import React from "react";
import ReactDOM from "react-dom/client";
import "swiper/swiper-bundle.css";
import "swiper/swiper.min.css";
import "./index.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import App from "./App";
import * as Sentry from "@sentry/react";

// ----------------------
//  SENTRY INITIALIZATION
// ----------------------
Sentry.init({
  dsn: "https://694c1626722d1ab9aa8936fd57afa2ac@o4504252219195392.ingest.us.sentry.io/4510306130984960",

  release: "superapp@1.0.0",

  // 🔥 Capture ALL errors + performance + network tracing
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Performance tracing
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^\//],

  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  // Ignore known harmless errors
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    /Request failed with status code 4\d\d/,
  ],

  // Optional debugging
  debug: false,

  // Send user IP automatically
  sendDefaultPii: true,
});

// ----------------------
//  GLOBAL ERROR CAPTURE
// ----------------------
window.addEventListener("unhandledrejection", (event) => {
  Sentry.captureException(event.reason);
});

window.addEventListener("error", (event) => {
  Sentry.captureException(event.error);
});

// ----------------------
//  RENDER APP
// ----------------------
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<h1>Something went wrong.</h1>}>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        limit={2}
        pauseOnHover={false}
        closeButton={true}
        theme="light"
      />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
